/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CluMigrationJobState } from 'src/clu/core/services/migration/cluMigrationSwaggers';
import { CluMigrationJobStore } from 'src/clu/core/stores/CluMigrationJobStore';
import { OperationHandler } from 'src/core/services/api/createOperationCall';
import { OperationDelayStrategies } from 'src/core/utils/api/operationDelayStrategies';
import { DisposableLifetime } from 'src/core/utils/lifetime';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';

export const getMigrationJobOperationHandler = (
    lifetime: DisposableLifetime,
    migrationJobStoreHouse: ResourceStoreHouse<CluMigrationJobStore>
): OperationHandler<CluMigrationJobState> => ({
    retryStrategy: res => !lifetime.isDisposed && res.data.status !== 'succeeded' && res.data.status !== 'failed',
    timeToDelay: OperationDelayStrategies.exponentialDelayStrategy,
    handleCall: data => {
        if (lifetime.isDisposed) {
            return;
        }

        const currentJobStore = migrationJobStoreHouse.findById(data.jobId);

        currentJobStore.updateData({
            luisAppsMigrationState: data.appsStatus ? [...data.appsStatus] : [],
            errors: data.errors?.map(e => e.message) ?? [],
            warnings: data.warnings?.map(w => w.message) ?? [],
            status: data.status === 'running' ? 'inProgress' : data.status
        });
    }
});
